export default "__VITE_ASSET__9oa5iUbo__"